export const useHeaderStore = defineStore('headerStore', {
	state: () => ({
		isHeaderVisible: false,
		headerTitle: null
	}),
	getters: {
		getHeaderVisible: (state) => {
			return state.isHeaderVisible;
		},
		getHeaderTitle: (state) => {
			return state.headerTitle;
		},
	},
	actions: {
		setHeaderVisible(value) {
			this.isHeaderVisible = value
		},
		setHeaderTitle(value) {
			this.headerTitle = value
		}
	}
})